import { ActivityComponentType } from '@stackflow/react'
import { useQuery } from '@tanstack/react-query'
import apis from '../../../modules/apis'
import { axiosGet } from '../../../modules/axiosHelper'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import EvaluationModalBody from '../../new-portal/lessons/evaluation/EvaluationModalBody'
import WebviewStackContainer from '../common/WebviewStackContainer'
interface ILessonEvaluationActivity {
  params: {
    lessonId: string
  }
}
const LessonEvaluationActivity: ActivityComponentType = ({ params }: ILessonEvaluationActivity) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()

  const { data, isFetching } = useQuery({
    queryKey: [params.lessonId, 'Evaluation'],
    queryFn: () => fetchData(),
  })

  const fetchData = async () => {
    const response = await axiosGet(apis.lesson.get(params.lessonId))

    return response
  }

  return (
    <WebviewStackContainer height="52px" onBack={pop}>
      <div className="h-full px-[16px]">
        {data && !isFetching && (
          <EvaluationModalBody lessonId={Number(params.lessonId)} lessonData={data.lesson} onClose={pop} />
        )}
      </div>
    </WebviewStackContainer>
  )
}

export default LessonEvaluationActivity
